import { NgModule } from '@angular/core';
import {
  // eslint-disable-next-line no-restricted-imports
  MatLegacyChipsModule as MatChipsModule,
  MatLegacyChipInputEvent as MatChipInputEvent
} from '@angular/material/legacy-chips';

export type TiimeChipInputEvent = MatChipInputEvent;

@NgModule({
  imports: [MatChipsModule],
  exports: [MatChipsModule]
})
export class TiimeChipsModule {}
